import { Box, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { getDeepViewValuesEntry } from "../../deepViewFieldMap";
import { isNegativeValue } from "../../deepViewNumbers";

const sectionLabelSx = {
  fontSize: "11px",
  fontWeight: 500,
  color: "#00000099",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
};

const cardLabelSx = {
  fontSize: "10px",
  fontWeight: 500,
  color: "#00000099",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
};

const cardNoteSx = {
  fontSize: "10px",
  color: "#00000099",
};

const operatorSx = {
  fontSize: "16px",
  color: "#00000061",
  flexShrink: 0,
};

interface Props {
  /** API key of the column the user clicked, e.g. "total_income_usd" */
  columnKey?: string;
  /** Label of the column the user clicked, e.g. "Total Income (USD)" */
  columnLabel?: string;
}

const NetImpact = ({ columnKey, columnLabel }: Props) => {
  const deepViewData = useSelector(
    (state: any) => state?.deepView?.deepViewData,
  );
  const valuesEntry = getDeepViewValuesEntry(deepViewData, columnKey);
  const adjustment = valuesEntry?.fmt_period_adj_signed_usd;

  return (
    <Box mt={1.5} mb={1.5}>
      <Typography sx={{ ...sectionLabelSx, mb: 0.5 }}>
        Net impact on {columnLabel}
      </Typography>

      <Stack direction="row" alignItems="center" spacing={1}>
        <Box
          sx={{
            flex: 1,
            border: "1px solid #E0E0E0",
            borderRadius: "8px",
            backgroundColor: "#FFFFFF",
            p: 1.5,
            textAlign: "center",
          }}
        >
          <Typography sx={cardLabelSx}>Unifier value</Typography>
          <Typography
            sx={{ fontSize: "18px", fontWeight: 700, color: "#000000DE" }}
          >
            {valuesEntry?.fmt_before_adj_usd ?? "-"}
          </Typography>
          <Typography sx={cardNoteSx}>daily_brand_performance</Typography>
        </Box>

        <Typography sx={operatorSx}>−</Typography>

        <Box
          sx={{
            flex: 1,
            border: "1px solid #E0E0E0",
            borderRadius: "8px",
            backgroundColor: "#F5F5F5",
            p: 1.5,
            textAlign: "center",
          }}
        >
          <Typography sx={cardLabelSx}>Adjustment</Typography>
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 700,
              color: isNegativeValue(adjustment) ? "#C62828" : "#000000DE",
            }}
          >
            {adjustment ?? "-"}
          </Typography>
          <Typography sx={cardNoteSx}>manual_adjustments</Typography>
        </Box>

        <Typography sx={operatorSx}>=</Typography>

        <Box
          sx={{
            flex: 1,
            border: "1px solid #E0E0E0",
            borderRadius: "8px",
            backgroundColor: "#FFFFFF",
            p: 1.5,
            textAlign: "center",
          }}
        >
          <Typography sx={cardLabelSx}>After adjustment</Typography>
          <Typography
            sx={{ fontSize: "18px", fontWeight: 700, color: "#7B1FA2" }}
          >
            {valuesEntry?.fmt_after_adj_usd ?? "-"}
          </Typography>
          <Typography sx={{ ...cardNoteSx, color: "#7B1FA2" }}>
            → final dashboard value
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};

export default NetImpact;
